import React, { useContext, useEffect, useState } from "react";
import Header from "../Comman/Header";
import Sidebar from "../Comman/Sidebar";
import Footer from "../Comman/Footer";
import axios from "axios";
import { IFTContext } from "../../IFTContext";
import { Link } from "react-router-dom";
import Pagination from "../Comman/Pagination";
import Copy from "../Comman/Copy";

export default function Members() {
  const { formatAddress } = useContext(IFTContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const getData = async () => {
    setLoading(true);
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "get",
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,
      })
      .then((res) => {
        // var dedata = decryptData(res.data);
        if (res.data.error) {
          setdata([]);
          setPages(0);
          setLoading(false);
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.dataLength / pageSize));
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages, pageSize, currentPage]);
  return (
    <>
      <div id="main-wrapper">
        <Header />
        <Sidebar />
        <div className="content-body">
          <div className="container-fluid">
            <div className="page-titles">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Dashboard</a>
                </li>
                <li className="breadcrumb-item active text-primary">Members</li>
              </ol>
            </div>
            <div className="form-head d-flex mb-3 mb-md-4 align-items-center">
              <div className="input-group search-area d-inline-flex me-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here"
                />
                <div className="input-group-append">
                  <button type="button" className="input-group-text">
                    <i className="flaticon-381-search-2" />
                  </button>
                </div>
              </div>

            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body ">
                    <div className="d-flex justify-content-between">
                      <div className="card-title text-light">Members</div>
                      <span
                        className="btn btn-primary btn-sm "
                        onClick={() => getData()}
                      >
                        <i
                          className="flaticon-381-repeat-1 "
                          aria-hidden="true"
                        />
                      </span>
                    </div>
                    <hr />
                    <div className="table-responsive">
                      <table
                        id="example5"
                        className="table table-striped patient-list mb-4 dataTablesCard fs-14"
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Status</th>
                            <th>Email</th>
                            <th>User ID</th>
                            <th>Reff ID</th>
                            <th>Staking</th>
                            <th>Date & Time</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan={8}>Data loading...</td>
                            </tr>
                          ) : (
                            ""
                          )}
                          {data.map((ele, i) => {
                            return (
                              <tr>
                                <td>{ele.id}</td>
                                <td>
                                  {ele.status === true
                                    ? "Active"
                                    : ele.status === true
                                      ? "Active"
                                      : ele.status === false
                                        ? "Not Active"
                                        : "Error"}
                                </td>

                                {/* <td>
                                  <a
                                    target="_blank"
                                    className="text-primary"
                                    href={`${process.env.REACT_APP_EXPLORER}address/${ele.address}`}
                                    rel="noreferrer"
                                  >
                                    {formatAddress(ele.address)}
                                  </a>
                                  {ele.address ? <Copy  data={ele.address}/> : ""}

                                </td> */}
                                {/* <td>
                                  <a
                                    target="_blank"
                                    className="text-primary"
                                    href={`${process.env.REACT_APP_EXPLORER}address/${ele.ref_address}`}
                                    rel="noreferrer"
                                  >
                                    {formatAddress(ele.ref_address)}&nbsp;
                                  </a>
                                  {ele.ref_address ? <Copy  data={ele.ref_address}/> : ""}
                                </td> */}
                                <td>

                                  {ele.email}&nbsp;

                                  {ele.email ? <Copy data={ele.email} /> : ""}
                                </td>
                                <td>

                                  {ele.user_id}&nbsp;

                                  {ele.user_id ? <Copy data={ele.user_id} /> : ""}
                                </td>
                                <td>
                                  {ele.ref_id}&nbsp;
                                  {ele.ref_id ? <Copy data={ele.ref_id} /> : ""}
                                </td>
                                <td>
                                  Amount: ${ele.t_staking}
                                </td>
                                <td>
                                  Register: {ele.datetime} <br />
                                </td>
                                <td>
                                  <span className="me-3">
                                    <Link
                                      className="edit-appointment"
                                      type="button"
                                      to={`/userreport/${ele.user_id}`}
                                    >
                                      <i
                                        className="fa fa-book fs-18 "
                                        aria-hidden="true"
                                      />
                                    </Link>
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
